<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">payments</span>
      <h2>Sortie d'argent</h2>
    </div>

    <p class="section-intro">
      Ce module est réservé à l'administrateur. Il affiche toutes les demandes de sortie d'argent
      soumises par les utilisateurs et permet de les accepter ou de les rejeter.
    </p>

    <!-- ===== TRAITER UNE DEMANDE ===== -->
    <h3 class="sub-title">Traiter une demande de sortie</h3>
    <p class="section-text">
      Lorsqu'un utilisateur soumet une demande de sortie d'argent (depuis le module Comptabilité),
      elle apparaît ici avec les détails suivants :
    </p>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Information</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Libellé</strong></td><td>Description de la dépense (non modifiable).</td></tr>
          <tr><td><strong>Montant</strong></td><td>Montant demandé (non modifiable).</td></tr>
          <tr><td><strong>Type de compte</strong></td><td>Compte concerné (non modifiable).</td></tr>
          <tr><td><strong>Fichier preuve</strong></td><td>Justificatif joint, si disponible (cliquez pour le télécharger).</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure : Accepter ou rejeter</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Sortie d'argent</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur une demande pour voir les détails (libellé, montant, justificatif).</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Examinez le justificatif et les informations.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>
          <strong>Si vous approuvez :</strong> Cliquez sur <span class="btn-ref">Accepter la demande</span>.
          Le montant est déduit du compte de l'utilisateur demandeur.
        </p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>
          <strong>Si vous refusez :</strong> Cliquez sur <span class="btn-ref">Rejeter la demande</span>.
          La demande est annulée et aucun montant n'est déduit.
        </p>
      </div>
    </div>

    <div class="info-card info">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#5b9bd5">info</span>
        Information
      </div>
      <p>
        Les demandes traitées (acceptées ou rejetées) restent visibles dans l'historique avec leur statut.
        Seul l'administrateur a accès à ce module.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocSortieArgent" };
</script>
